module.exports = __webpack_public_path__ + "static/img/londonchildrensmuseum.491bb45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/londonchildrensmuseum.png
// module id = JQlw
// module chunks = 0